import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import i18n from '../../core/services/i18n/i18n'
import styles from './event-date.css'

const cx = classnames.bind(styles)

function EventDate({
  direction,
  url,
  dates,
  title,
  status,
  isPastEvent,
  separator = '-',
}) {
  const wrapperClassName = cx({
    wrapper: true,
    [`wrapper--${direction}`]: true,
    ['wrapper--multidate']: Boolean(dates.length > 1),
  })

  return (
    <a className={wrapperClassName} href={url}>
      {isPastEvent && status === 'Postponed' ? (
        <div className={styles['date']}>
          <strong className={styles['date__weekday']}>
            {i18n.get('EventDate.Postponed')}
          </strong>
        </div>
      ) : (
        dates.map((date, i) => {
          return (
            <React.Fragment key={`${date.weekDay}${date.day}${date.month}`}>
              <div className={styles['date']}>
                <strong className={styles['date__weekday']}>
                  {date.weekDay}
                </strong>
                <small className={styles['date__day']}>{date.day}</small>
                <span className={styles['date__month']}>{date.month}</span>
                <span className={styles['date__year']}>{date.year}</span>
                {date.time && (
                  <span className={styles['date__time']}>{date.time}</span>
                )}
              </div>
              {i !== dates.length - 1 ? (
                <div className={styles['date__separator']}>
                  <span className={styles['date__separator__text']}>
                    {separator}
                  </span>
                </div>
              ) : null}
            </React.Fragment>
          )
        })
      )}
      <h4 className={styles['title']}>{title}</h4>
    </a>
  )
}

EventDate.propTypes = {
  direction: PropTypes.string,
  separator: PropTypes.string,
  url: PropTypes.string,
  dates: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string,
  status: PropTypes.string,
  isPastEvent: PropTypes.bool,
}

export default EventDate
